import { AssignTeachers } from "./assign-teachers.interface";

export class SectionSummarySubjects {
    employeeCount: number;
    result: AssignTeachers[];
}